import React, { Component } from 'react';
import { CustomSelectInput } from '@ookla/common-ui';
import styles from './datepicker.css';
import PropTypes from 'prop-types';

export default class DatePicker extends Component {
  static propTypes = {
    onDateSelected: PropTypes.func.isRequired,
    selectedOption: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired
  };
  static defaultProps = {
    options: []
  };
  render() {
    return (
      <CustomSelectInput
        label="Date"
        name="datepicker"
        className={styles.datepicker}
        inputClassName={styles.input}
        onChange={val => {
          this.setState({ selectedOption: val });
          this.props.onDateSelected(val);
        }}
        icon="calendar"
        theme="dark"
        value={this.props.selectedOption}
        options={this.props.options}
      />
    );
  }
}
